export const FETCH_REQUESTS = "/requests/";
